import { WidgetStreamStreamingConfig } from 'widgets/streaming/WidgetStreamConfig';

import { selectStreamKey } from './selectors';
import { clearFillGraphDataAction } from './actions';
import FillsGraphDataMessage from 'communication/types/fillsGraph/FillsGraphDataMessage';
import { createFillsGraphRequest } from 'widgets/fillsGraph/store/data/FillsGraphStreamRequest';
import FillsGraphByOrderIdOrSymQtyStreamRequest from 'communication/types/fillsGraph/FillsGraphByOrderIdOrSymQtyStreamRequest';
import { getFillsGraphMarketDataRequests } from 'widgets/fillsGraph/store/data/marketData';

export const fillsGraphWidgetStreamConfig: WidgetStreamStreamingConfig<
    FillsGraphByOrderIdOrSymQtyStreamRequest,
    FillsGraphDataMessage
> = {
    streamType: 'StreamingStream',
    configType: 'OrderIdsDependentWidgetStreamConfig',
    fallsBackToPortfolioSelection: true,
    startChannelDestination: 'startFillsGraphByOrderIdOrSymQtyStream',
    createPayload: createFillsGraphRequest,
    createMarketDataRequests: getFillsGraphMarketDataRequests,
    selectWidgetStreamKey: selectStreamKey,
    clearWidgetStreamData: clearFillGraphDataAction,
    subscriptions: { appSettings: true, widgetConfig: true },
};
